// extracted by mini-css-extract-plugin
module.exports = {"loading":"SpinningLoader_loading__2YuJU","content":"SpinningLoader_content__1PHMb"};